module.exports={CREDITS:"Credits",CREDITS_CONTENT:"This website uses graphics which are licensed.",GRAPHICS_TITLE:"Graphics and images"};